const rlog = Log.createModuleLogger('GridSelection');

const NEW_RECORD_GUID_PREFIX = 'NEW-RECORD';

class GridSelectionRange{
	constructor(recordGUIDs, fieldGUIDs){
		this.recordGUIDs = recordGUIDs || null;
		this.fieldGUIDs = fieldGUIDs || null;
	}
	getGridSelectionCells(){
		const cells = [];
		if(this.recordGUIDs !== null && this.fieldGUIDs !== null){
			for(let recordGuidIndex = 0; recordGuidIndex < this.recordGUIDs.length; recordGuidIndex++){
				for(let fieldGuidIndex = 0; fieldGuidIndex < this.fieldGUIDs.length; fieldGuidIndex++){
					cells.push(new GridSelectionCell(this.recordGUIDs[recordGuidIndex], this.fieldGUIDs[fieldGuidIndex]))
				}
			}
		}
		else{
			Assert.warn('getGridSelectionCells is not yet implemented for whole row and whole column selections');
		}
		return cells;
	}
}

class GridSelectionCell{
	constructor(recordGUID, fieldGUID){
		this.recordGUID = recordGUID || null;
		this.fieldGUID = fieldGUID || null;
	}
}


class GridSelection{
	constructor(parentVueComponent){
		this.parentVueComponent = parentVueComponent;
		this.highlightedRanges = [];
		this.selectedCell = null;
		this.selectedCellIsEditing = false;
		this.lastHighlightRangeChangeInitiator = "unknown";
	}
	clearHighlight(){
		rlog('clearHighlight');
		this.highlightedRanges = [];
		this.parentVueComponent.$pubsub.modules.tableNavigation.pub('gridSelectionChanged', {
			highlightedRanges: this.highlightedRanges,
			changeType: 'cleared',
			selectedCell: this.selectedCell
		});
		this.lastHighlightRangeChangeInitiator = "unknown";
	}
	clearGridSelection(){
		rlog('clearGridSelection');
		// debugger;
		this.highlightedRanges = [];
		this.selectedCell = null;
		this.parentVueComponent.$pubsub.modules.tableNavigation.pub('gridSelectionChanged', {
			highlightedRanges: this.highlightedRanges,
			changeType: 'cleared',
			selectedCell: this.selectedCell
		});
		this.parentVueComponent.$pubsub.modules.tableNavigation.pub('gridEditingChanged', {
			selectedCell: this.selectedCell,
			isEditing: this.selectedCellIsEditing,
		});
	}
	highlightCell(recordGUID, fieldGUID){
		const newSelectionItem = new GridSelectionRange([recordGUID], [fieldGUID]);
		this.highlightedRanges.push(newSelectionItem);
		this.parentVueComponent.$pubsub.modules.tableNavigation.pub('gridSelectionChanged', {
			highlightedRanges: this.highlightedRanges,
			changeType: 'added',
			selectionType: 'cell',
			newSelectionItem,
			selectedCell: this.selectedCell
		});
		rlog('highlightCell', recordGUID, fieldGUID);
	}
	highlightRange(recordGUIDs, fieldGUIDs, highlightRangeChangeInitiator=null){
		if (highlightRangeChangeInitiator) {
			this.lastHighlightRangeChangeInitiator = highlightRangeChangeInitiator;
		} else {
			this.lastHighlightRangeChangeInitiator = "unknown";
		}
		const newSelectionItem = new GridSelectionRange(recordGUIDs, fieldGUIDs);
		this.highlightedRanges.push(newSelectionItem);
		this.parentVueComponent.$pubsub.modules.tableNavigation.pub('gridSelectionChanged', {
			highlightedRanges: this.highlightedRanges,
			changeType: 'added',
			selectionType: 'range',
			newSelectionItem,
			selectedCell: this.selectedCell
		});
		rlog('highlightRange', recordGUIDs, fieldGUIDs);
	}
	getLastHighlightRangeChangeInitiator() {
		return this.lastHighlightRangeChangeInitiator;
	}
	highlightRecord(recordGUID){
		const newSelectionItem = new GridSelectionRange([recordGUID], null)
		this.highlightedRanges.push(newSelectionItem);
		this.parentVueComponent.$pubsub.modules.tableNavigation.pub('gridSelectionChanged', {
			highlightedRanges: this.highlightedRanges,
			changeType: 'added',
			selectionType: 'record',
			newSelectionItem,
			selectedCell: this.selectedCell
		});
		rlog('highlightRecord', recordGUID);
	}
	highlightField(fieldGUID){
		const newSelectionItem = new GridSelectionRange(null, [fieldGUID])
		this.highlightedRanges.push(newSelectionItem);
		this.parentVueComponent.$pubsub.modules.tableNavigation.pub('gridSelectionChanged', {
			highlightedRanges: this.highlightedRanges,
			changeType: 'added',
			selectionType: 'field',
			newSelectionItem,
			selectedCell: this.selectedCell
		});
		rlog('highlightField', fieldGUID);
	}
	highlightedRangeContainsCell(recordGUID, fieldGUID){
		for(let highlightedRangeIndex = 0; highlightedRangeIndex < this.highlightedRanges.length; highlightedRangeIndex++){
			if(this.highlightedRanges[highlightedRangeIndex].recordGUIDs.indexOf(recordGUID) >= 0 && this.highlightedRanges[highlightedRangeIndex].fieldGUIDs.indexOf(fieldGUID) >= 0){
				return true;
			}
		}
		return false;
	}
	getSelectedCell(){
		return this.selectedCell;
	}
	setSelectedCell(recordGUID, fieldGUID){
		this.selectedCell = new GridSelectionCell(recordGUID, fieldGUID);
		this.selectedCellIsEditing = false;
		this.parentVueComponent.$pubsub.modules.tableNavigation.pub('gridEditingChanged', {
			selectedCell: this.selectedCell,
			isEditing: this.selectedCellIsEditing,

		});
		rlog('setSelectedCell', this.selectedCell.recordGUID, this.selectedCell.fieldGUID);
	}
	clearSelectedCell(){
		this.selectedCell = null;
		this.selectedCellIsEditing = false;
		this.parentVueComponent.$pubsub.modules.tableNavigation.pub('gridEditingChanged', {
			selectedCell: this.selectedCell,
			isEditing: this.selectedCellIsEditing,

		});
		rlog('clearSelectedCell');
	}
	setEditingCell(recordGUID, fieldGUID){
		this.selectedCell = new GridSelectionCell(recordGUID, fieldGUID);
		this.selectedCellIsEditing = true;
		this.parentVueComponent.$pubsub.modules.tableNavigation.pub('gridEditingChanged', {
			selectedCell: this.selectedCell,
			isEditing: this.selectedCellIsEditing,
		});
		rlog('setEditingCell', this.selectedCell.recordGUID, this.selectedCell.fieldGUID);
	}
	clearEditingCell(){
		this.selectedCellIsEditing = false;
		this.parentVueComponent.$pubsub.modules.tableNavigation.pub('gridEditingChanged', {
			selectedCell: this.selectedCell,
			isEditing: this.selectedCellIsEditing,
		});
		rlog('clearEditingCell');
	}
	hasHighlightedCells(){
		return this.highlightedRanges.length !== 0;
	}
	getHighlightedCellsByRange(){
		return this.highlightedRanges.map(function withEachRange(highlightedRange){
			return highlightedRange.getGridSelectionCells();
		});
	}
	getHighlightedCells(){
		return this.getHighlightedCellsByRange().flat();
	}
	singleCellIsHighlighted(){
		return this.highlightedRanges.length === 1 && this.highlightedRanges[0].recordGUIDs.length === 1 && this.highlightedRanges[0].fieldGUIDs.length === 1;
	}

}

export default GridSelection;

export {NEW_RECORD_GUID_PREFIX};